module.exports = __webpack_public_path__ + "static/media/brookfield-energy.0a2e3b8e.jpg";